module.exports = __webpack_public_path__ + "img/login2.64f0edd5.png";